import { HttpClient } from '@angular/common/http';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "./ls-helper.service";
export class PaymentService extends BaseProvider {
    constructor(globals, http, ls) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.paymentFormIsVisible = false;
        this.paymentPlanFormIsVisible = false;
        this.paymentPlanInfoIsVisible = false;
        this.invoiceToPayId = 0;
        this.toggleDateFormatError = false;
        this.baseUrl = "invoice";
    }
    payAndSubmit(data, transactionId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/payment/${transactionId}`;
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    payAndSubmitAch(data, transactionId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/payment/ach/${transactionId}`;
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    pay(data, transactionId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/payment/new/${transactionId}`;
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    getFees(processTypeId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + `processType/config/${processTypeId}`;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getCosts(invoiceId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/payment/costs/${invoiceId}`;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    validateEventCode(code) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/eventCode/${code}/validate`;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    payWithEventCode(data, transactionId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/eventCode/payment/${transactionId}`;
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
}
PaymentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PaymentService_Factory() { return new PaymentService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService)); }, token: PaymentService, providedIn: "root" });
